import { Component, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Platform } from '@angular/cdk/platform';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-navigation-options',
  imports: [
    MatIcon,
    MatIconButton,
  ],
  templateUrl: './navigation-options.html',
  styleUrl: './navigation-options.scss',
})
export class NavigationOptions {
  public sheet = inject<MatBottomSheetRef<NavigationOptions>>(MatBottomSheetRef);
  public platform = inject(Platform);
  public data: google.maps.LatLngLiteral = inject(MAT_BOTTOM_SHEET_DATA);
}
